import {
 Box, Popover, Stack, Typography,
} from '@mui/material';
import {
  Link as LinkIcon,
  Facebook as FacebookIcon,
} from '@mui/icons-material';
import React from 'react';

interface ShareMenuProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  url: string;
  onCopySuccess: () => void;
  // Optional analytics hooks. Undefined on the public share page (no tracking there).
  onCopyClick?: () => void;
  onFacebookClick?: () => void;
}

function ShareMenuRow({
  iconBg,
  icon,
  label,
  onClick,
}: {
  iconBg: string;
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
}) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={1.5}
      onClick={onClick}
      sx={{
        px: 3,
        py: 1.5,
        cursor: 'pointer',
        '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: '100px',
          backgroundColor: iconBg,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
      <Typography
        sx={{
          fontFamily: 'Lexend, sans-serif',
          fontWeight: 400,
          fontSize: '16px',
          lineHeight: 1.5,
          color: 'common.black',
        }}
      >
        {label}
      </Typography>
    </Stack>
  );
}

function ShareMenu({
  open,
  anchorEl,
  onClose,
  url,
  onCopySuccess,
  onCopyClick,
  onFacebookClick,
}: ShareMenuProps) {
  const handleCopy = async () => {
    onCopyClick?.();
    try {
      await navigator.clipboard.writeText(url);
      onCopySuccess();
    } catch (err) {
      // Browser denied clipboard access — silent.
    }
    onClose();
  };

  const handleFacebook = () => {
    onFacebookClick?.();
    const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    window.open(fbUrl, '_blank', 'noopener,noreferrer,width=600,height=500');
    onClose();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      slotProps={{
        paper: {
          sx: {
            mt: 1,
            py: 1.5,
            borderRadius: '18px',
            width: 393,
            maxWidth: '90vw',
            boxShadow:
              '0px 6px 28px 0px rgba(0, 0, 0, 0.12), 0px 15px 22px 0px rgba(0, 0, 0, 0.14), 0px 8px 9px 0px rgba(0, 0, 0, 0.2)',
          },
        },
      }}
    >
      <ShareMenuRow
        iconBg="rgba(4, 30, 73, 0.08)"
        icon={<LinkIcon sx={{ fontSize: 24, color: 'common.black' }} />}
        label="Copy Link"
        onClick={handleCopy}
      />
      <ShareMenuRow
        iconBg="#0079fb"
        icon={<FacebookIcon sx={{ fontSize: 24, color: '#fff' }} />}
        label="Share to Facebook"
        onClick={handleFacebook}
      />
    </Popover>
  );
}

export default ShareMenu;
